import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { TABLE_BASE_CLASSNAME } from './Constants';
import { createTable } from './Table';
createComponents(".".concat(TABLE_BASE_CLASSNAME), createTable, NO_PATTERN_BUSINESS_LOGIC);
